import PropTypes from "prop-types"
import ClientDetails from "~/components/Clients/ClientDetails"
import RightContainer from "~/components/Clients/RightContainer"
import CourseLessonContentContainer from "~/components/Common/CourseLessonContentContainer"
import AddCourseToClient from "~/dialogs/AddCourseToClient"
import Page from "~/pages/Page"
import Router from "~/router"

const Details = ({ routes = [], ...rest }) => {
  return (
    <Page>
      <CourseLessonContentContainer
        leftComponent={<ClientDetails />}
        rightComponent={<RightContainer />}
      />
      <AddCourseToClient />
      <Router routes={routes} {...rest} />
    </Page>
  )
}

Details.propTypes = {
  routes: PropTypes.array,
}

export default Details
